'use client';

import { websiteEnv } from '@/constants/website-env';
import Link from 'next/link';

const ErrorFetchPage = () => {
  return (
    <div
      className='px-2.5 pt-10 lg_px-0'
      data-error-fetch-page='1'
    >
      <div className='flex flex-col items-center justify-center'>
        <p className='text-[30px] font-semibold text-colordefault '>Something went wrong!</p>
        <p className='mt-2.5'>Please refresh the page and try again</p>
        <div className='mt-5'>
          <p className='mb-5 text-center text-[22px] text-colordefault'>Explore AW Bridal Brand...</p>
          <ul className='flex flex-col gap-5 lg_flex-row'>
            <li>
              <div>
                <Link
                  href={`/wedding-dresses`}
                  className='flex flex-col items-center underline'
                  prefetch={false}
                >
                  <img
                    src={`${process.env.NEXT_PUBLIC_BASE_PATH}/media/wysiwyg/pagenotfound1.jpg`}
                    alt='Wedding Dresses'
                  />
                  <span>Wedding Dresses</span>
                </Link>
              </div>
            </li>
            <li>
              <div>
                <Link
                  href={`/bridesmaid-dresses`}
                  className='flex flex-col items-center underline'
                  prefetch={false}
                >
                  <img
                    src={`${process.env.NEXT_PUBLIC_BASE_PATH}/media/wysiwyg/pagenotfound2.jpg`}
                    alt='Bridesmaid Dresses'
                  />
                  <span>Bridesmaid Dresses</span>
                </Link>
              </div>
            </li>
            <li>
              <div>
                <Link
                  href={`/mother-of-the-bride-dresses`}
                  className='flex flex-col items-center underline'
                  prefetch={false}
                >
                  <img
                    src={`${process.env.NEXT_PUBLIC_BASE_PATH}/media/wysiwyg/pagenotfound3.jpg`}
                    alt='Mother of the Bride Dresses'
                  />
                  <span>Mother of the Brides</span>
                </Link>
              </div>
            </li>
            {websiteEnv.isUnitedStates ? (
              <li>
                <div>
                  <Link
                    href={`/wedding-accessories`}
                    className='flex flex-col items-center underline'
                    prefetch={false}
                  >
                    <img
                      src={`${process.env.NEXT_PUBLIC_BASE_PATH}/media/wysiwyg/pagenotfound4.jpg`}
                      alt='Wedding Accessories'
                    />
                    <span>Accessories</span>
                  </Link>
                </div>
              </li>
            ) : null}
            <li>
              <div>
                <Link
                  href={`/${websiteEnv.isUnitedStates ? 'ready-to-ship' : 'wedding-guest-dresses'}`}
                  className='flex flex-col items-center underline'
                  prefetch={false}
                >
                  <img
                    src={`${process.env.NEXT_PUBLIC_BASE_PATH}/media/wysiwyg/pagenotfound6.jpg`}
                    alt={websiteEnv.isUnitedStates ? 'Ready to Ship' : 'Wedding Guest Dresses'}
                  />
                  <span>{websiteEnv.isUnitedStates ? 'Ready to Ship' : 'Wedding Guest Dresses'}</span>
                </Link>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ErrorFetchPage;
